export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13913.5dc8fd7f.jpg";